import { IconNameType } from '@servicetitan/design-system';
import { injectable } from '@servicetitan/react-ioc';

import { HttpClient } from './http-client';

export interface AppSetting {
    key: string;
    value: string;
}

export type EHModuleAppType = 'route' | 'widget';

export type EHModuleLinkPlacement = 'header' | 'content' | 'footer';

export interface EHModule {
    id: number;
    apiScope: string;
    name: string;
    description: string;
    basePath: string;
    path: string;
    icon?: IconNameType;
    iconBgColor: string;
    packageUrl: string;
    rcPackageUrl: string;
    linkPlacement: EHModuleLinkPlacement;
    appType: EHModuleAppType;
    appSettings: AppSetting[];
}

export interface UserClaim {
    key: string;
    value: string;
}

export interface UserIdentificationInfo {
    id: string;
    email: string;
    name: string;
    role: string;
    networkId?: string;
}

export interface ConfigResponse {
    [key: string]: string;
}

@injectable()
export class EnterpriseHubApi {
    constructor(private readonly httpClient: HttpClient) {}

    get logoutUrl() {
        return `${this.httpClient.apiUrl}/account/logout`;
    }

    getLoggedInUserInfo() {
        return this.httpClient.get<UserClaim[]>('account/me');
    }

    getApps() {
        return this.httpClient.get<EHModule[]>('apps');
    }

    getConfigs() {
        return this.httpClient.get<ConfigResponse>('configs');
    }
}
